<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="isEdit ? '编辑数据' : '新增数据'"
    width="30%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form :model="storeFormData" :rules="storeFormRule" ref="storeFormRef">
        <el-form-item label="三级名称" prop="storageName">
          <el-input v-model="storeFormData.storageName" placeholder="请输入三级名称"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import storeMixin from './../../../storeMixin.js';
  export default {
    name: 'AddStoreDialog',
    props: {
      isEdit: {
        type: Boolean,
        default: false,
      },
      defaultValue: {
        type: String,
        default: '',
      },
    },
    mixins: [storeMixin],
    data() {
      return {
        dialogVisible: false,
        storeFormData: {
          storageName: '',
        },
        storeFormRule: {
          storageName: [{ required: true, message: '必填字段', trigger: 'blur' }],
        },
      };
    },
    methods: {
      openModal() {
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
        this.$refs.storeFormRef.resetFields(); // 重置表单
      },
      confirmHandler() {
        this.$refs.storeFormRef.validate(async (valid) => {
          if (valid) {
            if (this.isEdit) {
              this.$emit('edit', this.storeFormData);
            } else {
              this.$emit('newStoreHandler', this.storeFormData);
            }
            this.cancelHandler();
          }
        });
      },
    },
    watch: {
      defaultValue: {
        handler(val) {
          this.storeFormData.storageName = val;
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
